// extracted by mini-css-extract-plugin
export default {"profileMenu":"profileMenu_profileMenu__2ASRO","profileTabs":"profileMenu_profileTabs__ITsgA","logoutButton":"profileMenu_logoutButton__RiEe7"};